const VARIANT_LABELS: Record<string, string> = {
  classic: 'Classic',
  muflis: 'Muflis',
  ak47: 'AK47',
};

export type VariantTheme = 'green' | 'purple' | 'red';

const VARIANT_THEMES: Record<string, VariantTheme> = {
  classic: 'green',
  muflis: 'purple',
  ak47: 'red',
};

export const VARIANT_MINI_CARDS: Record<string, string[]> = {
  classic: ['A♠', 'K♦', 'Q♥'],
  muflis: ['8♣', '7♠', '6♣'],
  ak47: ['A♥', 'K♥', '4♥'],
};

export function variantTheme(code: string | null | undefined): VariantTheme {
  const key = (code || 'classic').trim().toLowerCase();
  return VARIANT_THEMES[key] || 'green';
}

export function formatVariantLabel(code: string | null | undefined): string {
  if (!code) return 'Classic';
  const key = code.trim().toLowerCase();
  return VARIANT_LABELS[key] || code;
}

export function variantCodesMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  return (a || 'Classic').trim().toLowerCase() === (b || 'Classic').trim().toLowerCase();
}
